import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export const useStore = create(
  devtools(
    persist(
      (set, get) => ({
        user: null,
        birds: [],
        blogPosts: [],
        gameScores: {},
        error: null,
        isLoading: false,

        initialize: async () => {
          set({ isLoading: true })
          try {
            await new Promise(resolve => setTimeout(resolve, 500))
            set({ isLoading: false })
          } catch (error) {
            set({ error: error.message, isLoading: false })
          }
        },

        setError: (error) => set({ error }),
        clearError: () => set({ error: null }),

        addGameScore: (game, score) => {
          const { gameScores } = get()
          const currentScores = gameScores[game] || []
          set({
            gameScores: {
              ...gameScores,
              [game]: [...currentScores, { score, date: new Date().toISOString() }]
            }
          })
        },
        
        updateBirds: (birds) => set({ birds }),
        updateBlogPosts: (posts) => set({ blogPosts: posts }),
      }),
      {
        name: 'bird-watching-storage',
        storage: {
          getItem: (name) => {
            const value = localStorage.getItem(name)
            return value ? JSON.parse(value) : null
          },
          setItem: (name, value) => {
            localStorage.setItem(name, JSON.stringify(value))
          },
          removeItem: (name) => {
            localStorage.removeItem(name)
          },
        },
      }
    ),
    { name: 'BirdWatchingStore' }
  )
)